import React, { useContext, useEffect, useState } from 'react'
// Icons
import { ReactComponent as PanIcon } from './icons/pan.svg'
import { ReactComponent as OrbitIcon } from './icons/orbit.svg'
import { ReactComponent as ZoomIcon } from './icons/zoom.svg'
import { AppConfig, AppConfigContext } from '../../../../context/AppConfig'
import use3DViewerEvent from '../../../../hooks/use3DViewerEvent'

function Guide({ className = '', wide, onEnd = () => {} }) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [firstIterationCompleted, setFirstIterationCompleted] = useState(false)
  const { isBrodskyApp, show_endless_animation } = useContext(AppConfigContext)
  const [interactionDetected, setInteractionDetected] = useState(false)
  const [cycleCount, setCycleCount] = useState(0)

  const content = [
    {
      icon: <OrbitIcon />,
      text: 'Orbit in any directions',
    },
    {
      icon: <ZoomIcon />,
      text: 'Zoom in or out',
    },
    {
      icon: <PanIcon />,
      text: 'Pan to reposition',
    },
  ]

  useEffect(() => {
    if (currentIndex === 0) {
      setTimeout(() => {
        setCurrentIndex(1)
      }, 3500)
    }
    if (currentIndex === 1) {
      setTimeout(() => {
        setCurrentIndex(2)
      }, 2000)
    }
    if (currentIndex === 2) {
      setTimeout(() => {
        setCurrentIndex(currentIndex + 1)
        setCycleCount(cycleCount + 1)
        setTimeout(() => {
          if ((!isBrodskyApp && !show_endless_animation) || interactionDetected) {
            if (isBrodskyApp || show_endless_animation || interactionDetected) {
              setShown(false)
              onEnd()
            } else {
              if( cycleCount < 2) {
                setCurrentIndex(0)
              }
            }
          } else {
            setCurrentIndex(0)
          }
        }, 600)
      }, 2000)
    }
  }, [currentIndex, onEnd, isBrodskyApp, interactionDetected, show_endless_animation, cycleCount])

  useEffect(() => {
    if (currentIndex === 3) {
      if (!firstIterationCompleted) {
        setFirstIterationCompleted(true)
      }
    }
  }, [currentIndex, firstIterationCompleted])

  const [shown, setShown] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setShown(true)
    }, 500)
  }, [])

  use3DViewerEvent('user-interaction', ({ event }) => {
    if (firstIterationCompleted && (isBrodskyApp || show_endless_animation || cycleCount > 0)) {
      setShown(false)
      onEnd()
    }
    setInteractionDetected(true)
  })

  return (
    <div className={`h-max ${shown ? 'fade-in' : 'opacity-0 '}  flex items-center justify-center ${className}`}>
      {content.map((i, index) => (
        <div
          key={index}
          className={`absolute  flex ${
            wide ? 'w-max' : 'flex-col w-[200px]'
          } items-center justify-end  h-[60px] top-0 left-0 ${index === currentIndex ? 'fade-in' : 'fade-out'}`}
        >
          <div className="opacity-80">{i.icon}</div>
          <div className={` ${wide ? 'ml-[16px]' : 'mt-[12px]'} text-[#3D4256]`}>{i.text}</div>
        </div>
      ))}
    </div>
  )
}

export default Guide
